import { c as _c } from "react/compiler-runtime";
import useTranslate from '@/contexts/i18nContext/hooks/useTranslate';
import { Select } from '@winelidays/wld-tsx-2/fields';
import OrderOption from './OrderOption';
const OrderSelect = t0 => {
    const $ = _c(12);
    let possibleOrders;
    let props;
    if ($[0] !== t0) {
        ({
            possibleOrders,
            ...props
        } = t0);
        $[0] = t0;
        $[1] = possibleOrders;
        $[2] = props;
    }
    else {
        possibleOrders = $[1];
        props = $[2];
    }
    const translate = useTranslate();
    let t1;
    if ($[3] !== translate) {
        t1 = translate("messages.order_by");
        $[3] = translate;
        $[4] = t1;
    }
    else {
        t1 = $[4];
    }
    let t2;
    if ($[5] !== possibleOrders) {
        t2 = possibleOrders.map(_temp);
        $[5] = possibleOrders;
        $[6] = t2;
    }
    else {
        t2 = $[6];
    }
    let t3;
    if ($[7] !== props || $[8] !== t1 || $[9] !== t2 || $[10] !== translate) {
        t3 = <Select id="order-select" arrowClassName="!border-current border-2" inputClassName="!border-none !bg-transparent font-semibold text-sm !text-right" label={t1} hideLabel={true} translate={translate} {...props}>{t2}</Select>;
        $[7] = props;
        $[8] = t1;
        $[9] = t2;
        $[10] = translate;
        $[11] = t3;
    }
    else {
        t3 = $[11];
    }
    return t3;
};
export default OrderSelect;
function _temp(order) {
    return <OrderOption key={order} option={order}/>;
}
